module.exports = __webpack_public_path__ + "static/media/CosmicAnni.c3b1baf9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CosmicAnni.jpeg
// module id = 245
// module chunks = 0